/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/no-static-element-interactions,
jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-has-content */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TopbarNav from './topbar_nav/TopbarNav';
import TopbarProfile from './TopbarProfile';
import SidebarSwipeable from './sidebar_mobile/SidebarSwipeable';
import { getUserPortfolio } from '../../../shared/services/apiGateway';
import '../../../shared/style/investorTopbar.css';

const TopbarInvestor = ({ user, isLoggedIn }) => {
  const [userPortfolio, setUserPortfolio] = useState({});
  const [hasLoadedPortfolio, setHasLoadedPortfolio] = useState(false);
  const matches = useMediaQuery('(max-width:991px)');
  const location = useLocation();
  const pageTitles = {
    '/available': 'Live Deals - Alumni Ventures',
    '/available-syndications': 'Live Deals - Alumni Ventures',
    '/available-funds': 'Live Funds - Alumni Ventures',
  };
  const pageTitle = pageTitles[location.pathname] || 'Alumni Ventures';
  const isLoginPage = ['/login', '/managed/login', '/log_in'].includes(location.pathname);
  let rightContent = null;

  if (user != null && isLoggedIn) {
    rightContent = <TopbarProfile user={user} />;
  } else if (!isLoginPage) {
    rightContent = (
      <Button
        component={Link}
        to="/login"
        variant="contained"
        color="secondary"
        size="large"
        style={{
          height: '36px',
          minHeight: '36px',
          maxHeight: '36px',
        }}
        sx={{
          minWidth: '108px',
          px: { xs: 1.75, md: 2 },
        }}
      >
        Log In
      </Button>
    );
  }

  useEffect(() => {
    const abortController = new AbortController();
    let ignore = false;

    async function fetchData() {
      setUserPortfolio({});
      setHasLoadedPortfolio(false);
      try {
        const portfolio = await getUserPortfolio(true, false, false, abortController.signal);
        if (!ignore && portfolio !== 'aborted' && portfolio.data) {
          setUserPortfolio(portfolio.data);
          setHasLoadedPortfolio(true);
        }
      } catch (error) {
        if (!ignore && error.statusCode === 404) {
          setHasLoadedPortfolio(true);
          return;
        }
        throw error;
      }
    }

    if (user) {
      fetchData();
    } else {
      setUserPortfolio({});
      setHasLoadedPortfolio(false);
    }

    return () => {
      ignore = true;
      abortController.abort();
    };
  }, [user]);

  return (
    <div
      className="topbar topbar--navigation investor-topbar"
      style={{ position: 'relative', zIndex: 1400 }}
    >
      <Helmet>
        <title>{pageTitle}</title>
        <link rel="shortcut icon" href={`${process.env.AVG_API_PATH}/favicon.ico`} sizes="16x16" />
      </Helmet>
      <div className="topbar__wrapper">
        <div className="topbar__left">
          {matches && user && (
            <SidebarSwipeable
              user={user}
              userPortfolio={userPortfolio}
              hasLoadedPortfolio={hasLoadedPortfolio}
            />
          )}
          <a
            style={{
              marginLeft: '15px', marginTop: '10px', marginRight: '15px', display: 'block', cursor: 'pointer',
            }}
            className="topbar__logo"
            onClick={() => window.location.replace(`${process.env.AVG_API_PATH}/`)}
          />
        </div>
        {user != null && (
          <div className="investor-topbar__center-nav">
            <TopbarNav
              user={user}
              userPortfolio={userPortfolio}
              hasLoadedPortfolio={hasLoadedPortfolio}
            />
          </div>
        )}
        <div
          className="topbar__right"
          style={!isLoggedIn && !isLoginPage ? { alignItems: 'center' } : undefined}
        >
          {rightContent}
        </div>
      </div>
    </div>
  );
};

TopbarInvestor.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: PropTypes.object,
  isLoggedIn: PropTypes.bool,
};

TopbarInvestor.defaultProps = {
  user: null,
  isLoggedIn: false,
};

function mapStateToProps(state) {
  const { auth } = state;
  const { user, isLoggedIn } = auth;
  return { user, isLoggedIn };
}

export default connect(mapStateToProps)(TopbarInvestor);
